function errorpageController($translate, $scope, coreService, $sce) {
// Assign this controller as the view-model.
  // It will be accessible as 'errorpageController' within the HTML template.
  var vm = this;
  vm.messages = [];
  vm.errorDetails = "";
  $scope.formatError = formatError;
  // Activate the controller.
  activate();

  // Activates the controller.
  function activate() {
    var model = coreService.getIdentityModel();
    // Read Identity Server's data model
    $scope.model = model;

    // Change display language
    if (model && model.ui_locales) {
        $translate.preferredLanguage(model.ui_locales);
    }

    if (model.errorMessages){
      vm.messages = model.errorMessages;
      vm.errorDetails =  model.errorMessages;
    } else if (model.errorMessage){
      vm.messages.push(model.errorMessage);
      vm.errorDetails =  model.errorMessage;
    }

    $translate(['application.error.title']) 
      .then(function(data) {        
        vm.errorDetails = data['application.error.title'] + vm.errorDetails; 
    }); 

  }

  function formatError(message){
    return $sce.getTrustedHtml(replaceAll(message, "\n", "<br>"));
  };  

  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }    
}

export default errorpageController;



// WEBPACK FOOTER //
// ./src/errorpage/errorpage.controller.js